import React, { Fragment, useState } from 'react';
import { H6, LI, P, UL, Image } from '../../../AbstractElements';
import { Card, CardBody, Media } from 'reactstrap';
import user from '../../../assets/images/user/user.png';
import { Link } from 'react-router-dom';
import {  EmailFilter,  MARKJENCO, MARKJENCOEMAIL, NEWMAIL, } from '../../../Constant';
import { EmailSidebarMenuList } from './EmailSidebarMenu';

const MailSidebar = () => {
  const [IsOpen, setIsOpen] = useState(false);
  const OnHandelClick = () => {
    setIsOpen(!IsOpen);
  };
  return (
    <Fragment>
      <div className='md-sidebar job-sidebar'>
        <a className='btn btn-primary md-sidebar-toggle' href='#javascript' onClick={OnHandelClick}>
          {EmailFilter}
        </a>
        <div className={`md-sidebar-aside email-left-aside ${IsOpen ? 'open' : ''}`}>
          <Card>
            <CardBody>
              <div className='email-app-sidebar'>
                <Media className='d-flex'>
                  <div className='d-flex-size-email'>
                    <Image className='me-3 rounded-circle' src={user} alt='' />
                  </div>
                  <div className='flex-grow-1'>
                    <H6 className='f-w-600'>{MARKJENCO}</H6>
                    <P>{MARKJENCOEMAIL}</P>
                  </div>
                </Media>
                <UL className='simple-list nav main-menu'>
                  <LI className='nav-item'>
                    <Link className='btn-primary btn-block btn-mail w-100' to={`${process.env.PUBLIC_URL}/email/email-compose`}>
                      <i className='icon-email me-2'></i> {NEWMAIL}
                    </Link>
                  </LI>

                  {EmailSidebarMenuList.map((item, i, arr) => (
                    <Fragment key={i}>
                      <LI className='nav-item'>
                        <a href="#javascript"> 
                          <span className='title'>
                            <i className={item.icon}></i> {item.title}
                          </span>
                          {item.notification && <span className='badge pull-right'>({item.notification})</span>}
                        </a>
                      </LI>

                      {Math.floor(arr.length / 2) === i + 1 && (
                        <LI>
                          <hr className='lightborder' />
                        </LI>
                      )}
                    </Fragment>
                  ))}
                </UL>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </Fragment>
  );
};
export default MailSidebar;
